import ProductItem2 from "@/components/catalog/product-sliders/ProductItem2.vue";
import ProductItem3 from "@/components/catalog/product-sliders/ProductItem3.vue";
import ProductItem4 from "@/components/catalog/product-sliders/ProductItem4.vue";
import ProductItem5 from "@/components/catalog/product-sliders/ProductItem5.vue";
import ProductItem from "@/components/catalog/product-sliders/ProductItem.vue";

export const productCardComponents = {
    v1: ProductItem,
    v2: ProductItem2,
    v3: ProductItem3,
    v4: ProductItem4,
    v5: ProductItem5
};

export const productCarouselVariantOptions = [
    { value: "v1", label: "Card clásica" },
    { value: "v2", label: "Card horizontal" },
    { value: "v3", label: "Card con botón" },
    { value: "v4", label: "Card minimal" },
    { value: "v5", label: "Card compacta" }
];

export const DEFAULT_PRODUCT_CAROUSEL_VARIANT = "v1";
